package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AttendanceHistoryResponse(
    val analytics: AttendanceHistoryCard? = null,
    val ledger: List<AttendanceHistoryLedgerItem> = emptyList(),
    val page: Int? = null,
    val limit: Int? = null,
    val total: Int? = null
)

@Serializable
data class AttendanceHistoryCard(
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("total_days") val totalDays: Int? = null,
    @SerialName("attendance_percentage") val attendancePercentage: Double? = null,
    @SerialName("present_days") val presentDays: Int? = null,
    @SerialName("absent_days") val absentDays: Int? = null,
    @SerialName("late_days") val lateDays: Int? = null,
    @SerialName("excused_days") val excusedDays: Int? = null,
    @SerialName("absent_morning_days") val absentMorningDays: Int? = null,
    @SerialName("absent_afternoon_days") val absentAfternoonDays: Int? = null
)

@Serializable
data class AttendanceHistoryLedgerItem(
    val id: String? = null,
    @SerialName("attendance_date") val attendanceDate: String? = null,
    val status: String? = null,
    val remarks: String? = null,
    @SerialName("recorded_by_staff_id") val recordedByStaffId: String? = null,
    @SerialName("created_at") val createdAt: String? = null
)
